import axios from 'axios';
import api from "./API";
import endpoints from "./ApiEndpointConstants";
import { getWebsiteConfig } from "./ConfigAPI";

// 缓存配置，避免重复请求
let cachedConfig = null;
let configPromise = null;
// 像素加载状态
let pixelLoaded = false;
let pixelLoadPromise = null;

const getConfig = async () => {
  // 已缓存直接返回
  if (cachedConfig) return cachedConfig;
  // 有正在进行的请求，复用它，避免并发重复调用
  if (configPromise) return configPromise;

  configPromise = (async () => {
    try {
      cachedConfig = await getWebsiteConfig();
      return cachedConfig;
    } catch (error) {
      console.error("获取配置失败:", error);
      // 返回默认配置
      cachedConfig = {
        pixel: "1378681159515837",
        conversion_token: "",
      };
      return cachedConfig;
    } finally {
      configPromise = null;
    }
  })();

  return configPromise;
};

export const Facebook = async (
  event_id,
  eventname,
  customdata,
  userdata = {
    em: "",
    ph: "",
    fn: "",
    ln: "",
    ct: "",
    st: "",
    zp: "",
    country: "",
    external_id: "",
    client_ip_address: "",
    client_user_agent: "",
    fbc: "",
    fbp: "",
    lead_id: "",
    anon_id: "",
    madid: "",
    page_id: "",
    page_scoped_user_id: "",
    ctwa_clid: "",
    ig_account_id: "",
    ig_sid: "",
  },
  orderNu
) => {
  let _fbc = "";
  let _fbp = "";

  try {
    const cookies = document.cookie.split(";");
    for (let cookie of cookies) {
      const [name, value] = cookie.trim().split("=");
      if (name === "_fbc") _fbc = decodeURIComponent(value);
      if (name === "_fbp") _fbp = decodeURIComponent(value);
    }
  } catch (e) {
    console.error("Error reading cookies:", e);
  }

  userdata["fbc"] = _fbc;
  userdata["fbp"] = _fbp;

  if (!userdata.client_ip_address) {
    delete userdata.client_ip_address;
  }
  if (!userdata.client_user_agent) {
    delete userdata.client_user_agent;
  }

  // 从动态配置获取 pixel 和 fbqToken
  const config = await getConfig();
  const pixel = config?.pixel || "1378681159515837";
  const fbqToken = config?.conversion_token || "";

  return api.post(endpoints.FACEBOOK, {
    event_id: event_id,
    eventname: eventname,
    customdata: customdata,
    userdata: userdata,
    fbqToken: fbqToken,
    pixel: pixel,
    orderNu: orderNu,
  }).catch(error => {
    // Ignore error silently to prevent console logs in development
    return null;
  });
};

/**
 * 动态加载 Facebook Pixel 脚本
 * 加载后 fbq 会自动写入 _fbp / _fbc cookie
 * @param {string} pixelId - Facebook Pixel ID
 * @returns {Promise<void>}
 */
export const loadFbPixel = (pixelId) => {
  if (pixelLoaded) return Promise.resolve();
  if (pixelLoadPromise) return pixelLoadPromise;

  pixelLoadPromise = new Promise((resolve) => {
    try {
      // 标准 Facebook Pixel 初始化模式
      // fbq 函数本身作为队列暂存器，脚本加载后会设置 callMethod
      window.fbq = function () {
        if (window.fbq.callMethod) {
          window.fbq.callMethod(...arguments);
        } else {
          window.fbq.queue.push(arguments);
        }
      };
      window.fbq.push = window.fbq;
      window.fbq.loaded = true;
      window.fbq.version = '2.0';
      window.fbq.queue = [];
      window._fbq = window.fbq;

      // 注入 Pixel 脚本
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.onload = () => {
        window.fbq('init', pixelId);
        window.fbq('track', 'PageView');
        pixelLoaded = true;
        resolve();
      };
      script.onerror = () => {
        console.error('Facebook Pixel 脚本加载失败');
        resolve(); // 不阻塞后续流程
      };
      document.head.appendChild(script);
    } catch (e) {
      console.error('Facebook Pixel 初始化异常:', e);
      resolve();
    }
  });

  return pixelLoadPromise;
};

/**
 * 创建优惠券码（从 Facebook 数据）
 * @param {Object} params - 请求参数
 * @param {string} params.fbp - Facebook _fbp cookie
 * @param {string} params.fbc - Facebook _fbc cookie
 * @param {string} params.eventId - 事件 ID
 * @param {string} params.ownPhone - WhatsApp 电话号码
 * @param {string} params.transformEvent - 转化事件名称
 * @param {string} params.pixel - Facebook Pixel ID
 * @param {string} params.fbqToken - Facebook 转化 API Token
 * @param {string} params.telegramChatId - Telegram 群组 ID
 * @param {string} params.countryCode - 国家代码
 */
export const createCouponCodeFormFbData = (params) => {
  const { fbp, fbc, eventId, ownPhone, transformEvent, pixel, fbqToken, telegramChatId, countryCode } = params;
  return axios.post(
    'https://webhook.manos-lux.com/api/order/create',
    { fbp, fbc, eventId, ownPhone, transformEvent, pixel, fbqToken, telegramChatId, countryCode },
    {
      headers: {
        'Content-Type': 'application/json',
      },
      timeout: 50000,
    }
  );
};

// 导出获取配置的方法供外部使用
export { getConfig };
